module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('header', {
    staticClass: "site-header",
    attrs: {
      "id": "masthead"
    }
  }, [_c('div', {
    staticClass: "nav-toggle",
    attrs: {
      "id": "toggle-icon"
    }
  }, [_c('div', {
    staticClass: "toggle-icon",
    attrs: {
      "onclick": "myToggleFunction()"
    }
  }, [(_vm.props.acf.menutoggleimage) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.menutoggleimage,
      "alt": "logo"
    }
  }) : _vm._e()]), _c('nav', {
    staticClass: "site-navigation"
  }, [_c('ul', {
    staticClass: "primary-menu"
  }, [_c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "#about-us"
    }
  }), _c('span', {
    staticClass: "header-nav-item",
    on: {
      "click": function($event) {
        _vm.scrollSectionAboutUs()
      }
    }
  }, [_vm._v("About Us")])]), _c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "#our-team"
    }
  }), _c('span', {
    staticClass: "header-nav-item",
    on: {
      "click": function($event) {
        _vm.scrollSectionOurTeam()
      }
    }
  }, [_vm._v("Our Team")])]), _c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "#covid-info"
    }
  }), _c('span', {
    staticClass: "header-nav-item",
    on: {
      "click": function($event) {
        _vm.scrollSectionCovid()
      }
    }
  }, [_vm._v("Covid-19")])]), _c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "#technology"
    }
  }), _c('span', {
    staticClass: "header-nav-item",
    on: {
      "click": function($event) {
        _vm.scrollSectionTechnology()
      }
    }
  }, [_vm._v("Technology")])]), _c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "#media"
    }
  }), _c('span', {
    staticClass: "header-nav-item",
    on: {
      "click": function($event) {
        _vm.scrollSectionMedia()
      }
    }
  }, [_vm._v("Media")])]), _c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal2",
      modifiers: {
        "modal2": true
      }
    }]
  }, [_vm._v("Contact"), _c('b-modal', {
    attrs: {
      "id": "modal2",
      "title": "Contact Us",
      "size": "xl",
      "hide-footer": ""
    }
  }, [(_vm.props.acf.menupopup) ? _c('div', {
    staticClass: "menu-modal-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.menupopup)
    }
  }) : _vm._e()])], 1)]), _vm._m(0), _vm._m(1)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "onclick": "removeClass()"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://local.demandforce.com/b/drcynthiab",
      "target": "_blank"
    }
  }, [_vm._v("Reviews")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.ckbpay.com/",
      "target": "_blank"
    }
  }, [_vm._v("Pay My Bill")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ea3274","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 808
// module chunks = 1